module.exports = __webpack_public_path__ + "media/images/cow-9e3bbe327e6f15cc93d0038d3b92d0c5.svg";